import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean, text } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';
import { formatDate } from '@/main/utils/dateFormatter';

const stories = storiesOf('Components/DMS/Form', module);
const g = { v: 'Validace', d: 'Default' };

stories
	.addDecorator(withKnobs)
	.add('Date picker ', () => ({
		template: `
		<dms-form :model="$data" :rules="rules">
			<dms-date-picker v-bind="$props" validationProperty="value" :value.sync="value" />
		</dms-form>
		`,
		data() {
			return {
				value: null,
			};
		},
		props: {
			label: {
				default: text('Label', 'Datum události', g.d),
			},
			placeholder: {
				default: text('Placeholder', 'Zvolte datum', g.d),
			},
			isRequired: {
				default: boolean('Povinné pole', true, g.d),
			},
			disabled: {
				default: boolean('Disabled', false, g.d),
			},
		},
		computed: {
			rules() {
				const rules = [
					{
						required: this.isRequired, trigger: ['change', 'blur'],
					},
				];

				return {
					value: rules,
				};
			},
		},
		methods: {
			formatDate(val) {
				return val instanceof Date ? formatDate(val.toUTCString()) : '-';
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
